import { render, staticRenderFns } from "./CeldaProyecto.vue?vue&type=template&id=acf7ba78&scoped=true&"
import script from "./CeldaProyecto.vue?vue&type=script&lang=js&"
export * from "./CeldaProyecto.vue?vue&type=script&lang=js&"
import style0 from "./CeldaProyecto.vue?vue&type=style&index=0&id=acf7ba78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf7ba78",
  null
  
)

export default component.exports